import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledDataGridContainer = styled(Box)(({ theme }) => ({
	height: '100%',
	width: '100%',
	minHeight: '400px',
	'& .MuiDataGrid-root': {
		border: `1px solid ${theme.palette.divider}`,
		color: theme.palette.text.primary,
		backgroundColor: theme.palette.background.paper,
	},
	'& .MuiDataGrid-columnHeaders': {
		backgroundColor: theme.palette.action.hover,
	},
	'& .MuiDataGrid-cell:focus': {
		outline: 'none',
	},
}));
